<template>

    <div v-if="playlist">

        <div class="playlist-name">
            {{ playlist.name }}
        </div>

        <div class="playlist-tracks-count text-stardust-grey">
            {{ playlist.trackcount }} Tracks.
        </div>


        <div class="form-group">

            <label for="playlistFromEmailInput">
                Sender Email:
            </label>

            <input class="form-control" id="playlistFromEmailInput" placeholder="me@example.com" v-model="fromEmail" />

        </div>

        <div class="form-group">

            <label for="playlistToEmailInput">
                Recipient Email (max. 3, comma-separated):
            </label>

            <input class="form-control" id="playlistToEmailInput" placeholder="them@example.com" v-model="email" />

        </div>

		 <div class="form-group">

            <label for="emailNotesInput">
                Playlist Notes:
            </label>

            <textarea class="form-control" id="emailNotesInput" placeholder="Email Notes (optional)" v-model="notes" cols="30" rows="7" />

        </div>

        <a class="btn btn-raised btn-xl font-weight-semibold share-button" v-bind:class="{ 'btn-success': sharing, 'btn-danger': !sharing }" href="#" v-on:click.prevent="emailPlaylist">
            <span v-if="!sharing">Share</span>
            <span v-if="sharing"><img src="/images/download-spinner.gif" alt="spinner" class="loading-icon">Sharing...</span>
        </a>

        <div class="form-group row">

            <div class="col-12">

                <label><br /><br /> <strong>Or</strong> share using the URL below</label>

                <textarea v-model="copiedPlaylistDetails" id="playlistData" class="d-none"></textarea>

            </div>
            
            <div class="col-sm-10">
                <input class="form-control" type="text" :value="copiedPlaylistDetails" readonly />
            </div>
            
            <div class="col-sm-2 copy-playlist">
                <a href="#" class="btn btn-primary btn-block btn-sm copy-playlist-details-button" v-bind:class="{ 'btn-success': copied }" data-clipboard-action="copy" data-clipboard-target="#playlistData"><span v-if="!copied">Copy</span> <span v-if="copied">Copied</span> </a>
            </div>
            
        </div>

    </div>

</template>

<script>

	import Vue from 'vue';
    import Clipboard from 'clipboard';
    import { playerService } from '../player-service';

	export default Vue.component(
	  'share-playlist',
	  {

		  data: function () {

			  return {

				  playlist: null,
				  notes: null,
				  email: null,
                  fromEmail: window.authenticatedUserEmail ? window.authenticatedUserEmail : '',
                  copiedPlaylistDetails: null,
                  copied: false,
                  sharing: false

              };

		  },

		  mounted: function () {

              playerService.$on( 'user-updated', () => {
                  this.fromEmail = window.authenticatedUserEmail ? window.authenticatedUserEmail : '';
              } );

			  // Change the edit playlist contents depending on whats passed to it.
			  playerService.$on(
				'share-playlist',
				( playlist ) => {

					// Update curr track for modal.
					this.playlist = playlist;

			  		this.reset();

					// Open the modal.
					window.webpackOpenBsModalWorkaround( '#sharePlaylistModal' );


                    if(this.fromEmail) {
                        setTimeout(function() {
                            $('#playlistFromEmailInput').attr('readonly', true);
                        }, 250);
                    }
				}
			  );

		  },

		  methods: {

		  	emailPlaylist: function() {

                this.sharing = true;
				playerService.emailPlaylist( this.playlist, this.email, this.notes, this.fromEmail );

            },

              getWindowUrl: function() {

                  if ( !window.location.origin ) {
                      window.location.origin = window.location.protocol + '//' + window.location.hostname +
                          ( window.location.port ? ':' + window.location.port : '' );
                  }

                  return window.location.origin;

              },

		  	reset: function() {

		  	    let ctx = this;

				this.notes = null;
				this.email = null;

                this.copiedPlaylistDetails = this.getWindowUrl() + '/player?view-playlist=' + this.playlist.id;

                if (this.clipboardPlugin) {
                    this.clipboardPlugin.destroy();
                }

                this.clipboardPlugin = new Clipboard('.copy-playlist-details-button', {
                    container: document.getElementById('sharePlaylistModal'),
                    text: function (trigger) {
                        return ctx.copiedPlaylistDetails
                    }
                });

                this.copied = false;
                this.sharing = false;

                this.clipboardPlugin.on('success', function (e) {

                    ctx.copied = true;

                    e.clearSelection();

                });

            },

            copy: function () {

		  	    this.copied = true;

            },

		  },

		  watch: {

			  playlist: function( value ) {
				  this.reset();
			  }

		  }

	  }
	);

</script>
